import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { intlShape } from 'react-intl';

import { IconCoreSettings, IconShapeArrowDown } from '@xingternal/malt-icon';
import Modal, { ModalContainer, ModalContent } from '@xingternal/malt-modal';

import SettingsDropdownList from './SettingsDropdownList';
import styles from './index.css';

class SettingsDropdown extends Component {
  static propTypes = {
    intl: intlShape,
    isPremium: PropTypes.bool.isRequired,
    links: PropTypes.array.isRequired,
  };

  state = {
    opened: false,
  };

  toggle = () => {
    this.setState({
      opened: !this.state.opened,
    });
  };

  close = () => {
    this.setState({
      opened: false,
    });
  };

  render() {
    const {
      intl: { formatMessage },
      isPremium,
      links,
    } = this.props;
    const label = formatMessage({ id: 'A11Y_SETTINGS_DROPDOWN_LABEL' });
    return (
      <ModalContainer className={styles.ddWrapper}>
        <button
          aria-label={label}
          className={classNames(styles.settings, {
            [styles.userIsPremium]: isPremium,
          })}
          onClick={this.toggle}
        >
          <div className={styles.settingsWrapper}>
            <span className={styles.inner}>
              <IconCoreSettings className={styles.settingsIcon} />
            </span>
            <span className={styles.inner}>
              <IconShapeArrowDown className={styles.settingsArrow} />
            </span>
          </div>
        </button>

        {this.state.opened && (
          <Modal left onOutsideClick={this.close}>
            <ModalContent>
              <SettingsDropdownList links={links} />
            </ModalContent>
          </Modal>
        )}
      </ModalContainer>
    );
  }
}

SettingsDropdown.displayName = 'SettingsDropdown';

export default SettingsDropdown;
